var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.13 197.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#60b18c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.56 138.19 0 84.63 0 191.75 53.56 138.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.57 138.19 197.13 191.75 197.13 84.63 143.57 138.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.51 77.38 18.81 92.69 18.81 62.08 3.51 77.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.75,197.13l-67.86-67.86a35.86,35.86,0,0,0-50.65,0L5.38,197.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.69,12.21h59.75a42.65,42.65,0,0,0-59.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.22,19.81H34.9a8.49,8.49,0,0,0-8.48,8.49v72l32.52,32.52,8.92-8.92a43.49,43.49,0,0,1,61.41,0l8.92,8.92,32.52-32.52v-72A8.49,8.49,0,0,0,162.22,19.81Zm-40.37,54.9H106.34V90.22A7.78,7.78,0,0,1,98.56,98h0a7.77,7.77,0,0,1-7.77-7.78V74.71H75.28a7.78,7.78,0,0,1-7.78-7.78h0a7.77,7.77,0,0,1,7.78-7.77H90.79V43.65a7.77,7.77,0,0,1,7.77-7.78h0a7.78,7.78,0,0,1,7.78,7.78V59.16h15.51a7.77,7.77,0,0,1,7.78,7.77h0A7.78,7.78,0,0,1,121.85,74.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "193.62 77.38 178.31 62.08 178.31 92.69 193.62 77.38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.f14912579b5e62e0d9741d13d363281d.svg";
export { ForwardRef as ReactComponent };